module.exports = __webpack_public_path__ + "static/media/sologo_infinitum_azul.0e6d90e8.png";